var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"app":"","color":"grey lighten-1"}},[_c('v-spacer'),_c('span',{staticClass:"overline"},[_vm._v("© "+_vm._s(new Date().getFullYear())+" SECRETARÍA GENERAL - Administrador de servicios V."+_vm._s(_vm.systemVersion))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }